if (
  typeof Array !== undefined
  && Array.prototype
  && !Array.prototype.includesAll
) {
  Object.defineProperty(Array.prototype, 'includesAll', {
    value(...args) {
      for (const a of args.flat()) {
        if (!this.includes(a)) return false;
      }
      return true;
    }
  });
}